import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * BlogPostAds — JB blog post banner (1280×720). Figma source: 1429:808.
 *
 * Single editable title (gradient white→transparent) + a speech-bubble
 * subtitle. Bg is the rotated "Laptop and Light" photo, baked per-template.
 */
const BlogPostAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  // Per-template custom bg wins over the shared one (only when locked);
  // unlocking falls back to .main automatically.
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  // Manifest miss is expected during channel-switch transitions (URL params
  // updated before useSetting commits) and for combos that haven't been baked
  // yet. Soft-fall-through: skip the background rather than crashing the page.
  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* Tail path lifted verbatim from Figma node 1429:815 (Vector 1).
           * The bubble (Rectangle 1 + tail) is one Union in Figma carrying
           * a single `linear-gradient(135deg, #211104, #472407)`. The CSS
           * applies that gradient to .subtitle (the rect); the tail's SVG
           * gradient uses `userSpaceOnUse` with x1/y1/x2/y2 in the BUBBLE's
           * coordinate system (origin at rect top-left, ending at rect
           * bottom-right at 495.03×151.77) so the gradient continues across
           * both shapes seamlessly. The tail offset relative to the rect
           * (-13.589, 141.023) is baked into x1/y1/x2/y2 below. */}
          <svg
            className="tpl-bubble__tail"
            viewBox="0 0 53 61"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="BlogPostAds-tail-gradient"
                gradientUnits="userSpaceOnUse"
                x1="13.589"
                y1="-141.023"
                x2="508.619"
                y2="10.751"
              >
                <stop offset="0" stopColor="#211104" />
                <stop offset="1" stopColor="#472407" />
              </linearGradient>
            </defs>
            <path
              d="M0 60.6076C0 60.6076 13.6935 23.8373 13.6935 0L52.9999 28.6555C33.4736 51.732 0 60.6076 0 60.6076Z"
              fill="url(#BlogPostAds-tail-gradient)"
            />
          </svg>
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default BlogPostAds;
